module.exports = __webpack_public_path__ + "img/search.d1c0fbda.svg";